import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const TimerIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g fill="#444" transform="scale(0.01953125 0.01953125)"><path d="M835.584 363.52c53.475 68.532 85.741 155.885 85.741 250.774 0 226.216-183.384 409.6-409.6 409.6s-409.6-183.384-409.6-409.6c0-208.264 155.434-380.225 356.625-406.206l2.050-0.216v-105.472h102.4v105.472c74.752 9.216 143.36 38.912 199.68 82.944l74.752-74.752 72.704 72.704-74.752 74.24zM512 921.6c169.662 0 307.2-137.538 307.2-307.2s-137.538-307.2-307.2-307.2v0c-169.662 0-307.2 137.538-307.2 307.2s137.538 307.2 307.2 307.2v0zM358.4 0h307.2v102.4h-307.2v-102.4zM620.544 433.152l72.704 72.704-181.248 180.224-72.192-71.68 180.736-181.248z" /></g>
  </SvgIcon>;
};
